import { render } from "./ContactSupportView.vue?vue&type=template&id=b77284c0&scoped=true"
import script from "./ContactSupportView.vue?vue&type=script&lang=js"
export * from "./ContactSupportView.vue?vue&type=script&lang=js"

import "./ContactSupportView.vue?vue&type=style&index=0&id=b77284c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77284c0"]])

export default __exports__